import React from "react";
import { useState } from "react";
import PersonalLoanBankOffer from "./BankOffer/PersonalLoanBankOffer";
import BusinessLoanBankOffer from "./BankOffer/BusinessLoanBankOffer";
import MortgageLoanBankOffer from "./BankOffer/MotgageLoanBankOffer";
import HomeLoanBankOffer from "./BankOffer/HomeLoanBankOffer"
import DoctorLoanBankOffer from "./BankOffer/DoctorLoanBankOffer";


const OurPricing = () => {

  return (
    <div className="pricing-main">
      <h4 className="bank-offer-header"> “Looking for higher <br /><span >Funding?”</span> </h4>
      <div className="loan-bank-offer">
        <PersonalLoanBankOffer />
      </div>
      <div className="loan-bank-offer">
        <BusinessLoanBankOffer />
      </div>
      <div className="loan-bank-offer">
        <HomeLoanBankOffer />
      </div>
      <div className="loan-bank-offer">
        <MortgageLoanBankOffer />
      </div>
      <div className="loan-bank-offer">
        <DoctorLoanBankOffer />
      </div>
    </div>
  );
};
export default OurPricing;
